import React, { useState, useImperativeHandle, forwardRef } from 'react'
import Button from '@material-ui/core/Button'
import { useAuthDataContext } from '../../../__providers/AuthProvider'

let player
function VideoComment(props, ref) {
    const auth = useAuthDataContext()

    const [major, setMajor] = useState({
        blur: false,
        popup: false,
    })

    useImperativeHandle(ref, () => ({
        open: (videoId, startPos, endPos) => handleOpen(videoId, startPos, endPos),
        close: () => handleClose()
    }))

    const handleOpen = (videoId, startPos, endPos) => {
        setMajor(major => ({
            ...major,
            blur: true,
        }))

        setTimeout(() => {
            setMajor(major => ({
                ...major,
                popup: true
            }))

            player = window.videojs('video', {
                controlBar: {
                    fullscreenToggle: true,
                },
                autoplay: false,
                html5: {
                    hls: {
                        overrideNative: true,
                        enableLowInitialPlaylist: true,
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false,
                    nativeTextTracks: false
                }
            });
            player.ready(() => {
                var url = `https://aos.danielstandard.com/api/manifest/${videoId}/dsab.m3u8?token=${auth.user.token}`
                var start = startPos;
                var end = endPos;


                player.src({
                    src: url,
                    type: 'application/x-mpegURL',
                    // overrideNative: true,
                    keySystems: {
                        // 'org..clearkey': 'http://localhost/avto-obuchenie/public/api/streamkeys?token=' + auth.user.token,
                    }
                });
                if (start || end) {
                    let opts = {
                        restart_beginning: true
                    };
                    if (start) {
                        opts.start = start;
                    }
                    if (end) {
                        opts.end = end;
                    }

                    player.offset(opts);
                }
                // player.on('fullscreenchange', function() {
                //     if (player.isFullscreen()) {
                //         player.exitFullscreen();
                //     }
                // });
                // let fullScreenElement = document.getElementsByClassName("vjs-fullscreen-control")[0];
                // if (window.videojs.browser.IS_IOS) {
                //     fullScreenElement.parentNode.removeChild(fullScreenElement);
                // }
                if (player.tech_) {
                    player.tech_.off('dblclick');
                }
            });
        }, 50)
    }

    const handleClose = () => {
        const video = document.querySelector('#video_html5_api')
        video.pause()

        setMajor(major => ({
            ...major,
            popup: false
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                blur: false,
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={major.blur ? 'visible' : ''}>
            <div className={`box video-comment-modal ${major.popup ? 'show' : ''}`}>
                <video
                    id="video"
                    className="video-js vjs-big-play-centered"
                    controls
                    autoPlay
                    playsInline={true}
                    preload="auto"
                    disablePictureInPicture
                >
                    <p className="vjs-no-js">
                        За да видите това видео, моля, активирайте JavaScript или обновете Вашият уеб браузър, с такъв, който поддържа HTML5 видео.
                    </p>
                </video>
                <Button className="btn-primary" onClick={handleClose}>
                    Затвори
                </Button>
            </div>
        </div >
    )
}

export default forwardRef(VideoComment)